import { createContext } from 'react';
import type { AppUser } from '../types/auth';

export interface AuthContextValue {
  user: AppUser | null;
  loading: boolean;
  configurationReady: boolean;
  demoAvailable: boolean;
  signInWithJustbit: () => Promise<void>;
  signIn: (email: string, password: string) => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
  signOut: () => Promise<void>;
  enterDemo: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
